<template>
  <div class="image-upload">

    <v-img
      v-if="previewUrl && !isSvg"
      max-height="480"
      :aspect-ratio="1.5"
      contain
      class="grey lighten-3 rounded mb-6"
      :src="previewUrl"
      :lazy-src="previewUrl"
    />

    <inline-svg
      v-else-if="previewUrl && isSvg"
      :src="previewUrl"
    />

  </div>
</template>
<script>
import get from 'lodash/get'
import InlineSvg from 'vue-inline-svg'

export default {
  props: {
    value: {
      type: [String, Object, File],
      default () {
        return null
      }
    }
  },

  components: {
    InlineSvg
  },
  computed: {
    previewUrl () {
      if (this.value instanceof File) {
        return URL.createObjectURL(new File([this.value], this.value.name))
      }

      if (this.value instanceof Object) {
        return get(this.value, 'url')
      }

      return null
    },

    isSvg () {
      if (this.value instanceof File && this.value.type === 'image/svg+xml') {
        return true
      }
      return false
    }
  }
}
</script>
